import { Entity } from "../../Entity";
import { MessageInterface } from "./MessageInterface";
import MessageFactory from "../../Factories/MessageFactory";
import { FactoryInterface } from "../../FactoryInterface";

class Message extends Entity implements MessageInterface {
  constructor(public data) {
    super();
  }

  public getFactory(): FactoryInterface {
    return MessageFactory;
  }

  get id(): number {
    return this.data.id;
  }

  get agencyId(): number {
    return this.data.agencyId;
  }

  get createdAt(): Date {
    return this.data.createdAt;
  }

  get createdBy(): number {
    return this.data.createdBy;
  }

  get updatedAt(): Date {
    return this.data.updatedAt;
  }

  get updatedBy(): number {
    return this.data.updatedBy;
  }

  get removed(): boolean {
    return this.data.removed;
  }

  get statusId(): number {
    return this.data.statusId;
  }

  get conversationId(): number {
    return this.data.conversationId;
  }

  get senderId(): number {
    return this.data.senderId;
  }

  get message(): string {
    return this.data.message;
  }

  get notificationChannels(): any[] {
    return this.data.notificationChannels;
  }

  get isEmailNotificationFailed(): boolean {
    // TODO fix hardcoded value
    return this.data.notificationChannels.find(channel => channel?.id === 1)?.notificationStatus?.failed;
  }

  get isSmsNotificationFailed(): boolean {
    // TODO fix hardcoded value
    return this.data.notificationChannels.find(channel => channel?.id === 2)?.notificationStatus?.failed;
  }

  get senderDisplayName(): string {
    return this.data.senderDisplayName;
  }
}

export { Message }
